var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-modal-sub-header"},[_c('div',{staticClass:"r-modal-sub-header--wrapper"},[_c('span',{staticClass:"r-modal-sub-header--title"},[_vm._v(_vm._s(_vm.title))])]),_c('r-hr',{attrs:{"hrStyle":"sub-primary"}}),_c('div',{staticClass:"r-modal-sub-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }